// Application constants

export const ROUTES = {
  HOME: '/',
  LAB_3D_HOME: '/lab/3d-home',
  ABOUT: '/about',
  MISSION: '/mission',
  GET_HELP: '/get-help',
  DONATE: '/donate',
  VOLUNTEER: '/volunteer',
  VOLUNTEER_LOGIN: '/volunteer/login',
  VOLUNTEER_DASHBOARD: '/volunteer/dashboard',
  VOLUNTEER_RESET_PASSWORD: '/volunteer/reset-password',
  BLOG: '/blog',
  BLOG_POST: '/blog/:slug',
  CONTACT: '/contact',
  ADMIN_LAUNCH: '/admin',
  ADMIN_TODAY: '/admin/today',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ADMIN_INTAKE: '/admin/intake',
  ADMIN_ORGANIZATIONS: '/admin/organizations',
  ADMIN_CLIENTS: '/admin/clients',
  ADMIN_CLIENT_NEW: '/admin/clients/new',
  ADMIN_CLIENT_EDIT: '/admin/clients/:clientId/edit',
  ADMIN_DISTRIBUTION: '/admin/distribution',
  ADMIN_SCHEDULE: '/admin/schedule',
  ADMIN_TASKS: '/admin/tasks',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_INBOX: '/admin/inbox',
  ADMIN_SETTINGS: '/admin/settings',
  PRIVACY: '/privacy',
  TERMS: '/terms',
} as const

